import { apiRequest } from "./Api";


export const createNewTeam = (data: any) =>
    apiRequest<any, unknown>("POST", "team/store", data);

export const getTeams = (data?: any) =>
    apiRequest<any, any>("GET", "team", null, undefined, data);

export const updateTeam = (data?: any) =>
    apiRequest<any, any>("POST", "team/update", data);

export const deleteTeam = (data?: any) =>
    apiRequest<any, any>("POST", "team/delete", data);

export const changeTeamStatus = (data?: any) =>
    apiRequest<any, any>("POST", "team/change-status", data);

export const addNewQualityQuestion = (data?: any) =>
    apiRequest<any, any>("POST", "costumers/quality/questions/store", data);

export const deleteQualityQuestion = (id?: any) =>
    apiRequest<any, any>("DELETE", "costumers/quality/questions/delete/" + id);

export const changePassword = (data?: any) =>
    apiRequest<any, any>("POST", "update-password", data);